import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { DataService } from 'src/app/core/services/data/data.service';

@Component({
  selector: 'app-mi-creation-sandbox',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
  ],
  templateUrl: './mi-creation-sandbox.component.html',
  styleUrl: './mi-creation-sandbox.component.scss',
})
export class MiCreationSandboxComponent implements OnInit {
  dataService = inject(DataService);
  appGeneralStateService = inject(AppGeneralStateService);

  ngOnInit(): void {}
}
